<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 48 48" :class="[`${prefix}-icon`, `${prefix}-icon-pin-fill`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_ba237fc2b6__a"><rect width="48" height="48" rx="0"/></clipPath></defs><g clip-path="url(#svg_ba237fc2b6__a)"><path d="M26.6355,5.327462C25.9718,4.836141,25.0488,4.9042572,24.4644,5.487672L24.4666,5.492123C23.8161,6.14368,23.8161,7.19921,24.4666,7.85077L26.3918,9.77652L21.7636,14.40607L11.71339,14.40607C10.08952,14.40607,8.53461,15.0514,7.38677,16.1995L7.11761,16.471C5.597174,17.9917,5.597174,20.4575,7.11761,21.9782L15.3862,30.2493L5.491783,40.1487L5.329396,40.3356C4.807694,41.0377,4.9165712,42.0237,5.578896,42.595C6.24122,43.1663,7.23217,43.129,7.84973,42.5096L17.7453,32.6091L25.9923,40.8586C27.5126,42.3795,29.9777,42.3795,31.4979,40.8586L31.7693,40.5871L32.0696,40.2645C33.0315,39.1519,33.5606,37.7301,33.56,36.2592L33.56,26.2082L38.1902,21.5784L40.1403,23.5291L40.3272,23.6916C41.0292,24.2211,42.0217,24.1147,42.5956,23.4484C43.1695,22.782,43.1279,21.7845,42.5005,21.1682L26.8246,5.487672L26.6355,5.327462Z" fill-rule="evenodd"/></g></svg>
</template>
<script>

export default {
  name: 'IconPinFill',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
